import React from 'react';
import moment from 'moment';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import { TextMessage } from 'components/tt-forms/common';
import { DeleteDialog } from 'modules/dialog';
import TextTruncate from 'react-text-truncate';
import { CheckPermission } from 'modules/login/CheckPermission';
import { ShowIf } from 'components/utils';
import { get } from 'lodash';

class RowItemListHandleOldLetters extends React.Component {

  constructor(props, context) {
    super(props, context);

    this.state = {
      type: this.props.type
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.type && this.props.type !== nextProps.type) {
      this.setState({type: nextProps.type});
    }
  }

  showThongTinCongDan() {
    let size = '';
    if (this.props.item && this.props.item.listNguoiDungDon && this.props.item.listNguoiDungDon.length) {
      size = this.props.item.listNguoiDungDon.length;
    }
    if (!size) {
      return null;
    }
    return (
      <div>
        <li className="txt-bold">{this.props.item.listNguoiDungDon[0].hoVaTen}</li>
        <li>{this.getLocal(this.props.item.listNguoiDungDon[0])}</li>
        <li>{this.props.item.listNguoiDungDon[0].soDienThoai}</li>
      </div>
    );
  }

  checkNguonDon(type) {
    let userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
    let nguonDonText = '';
    let nguonDontype = '';
    let result = '';
    if (this.props.item && this.props.item.nguonDonInfo) {
      let dataNguonDon = this.props.item.nguonDonInfo;
      nguonDonText = dataNguonDon.ten;
      nguonDontype = dataNguonDon.type;
    }
    if (type === 'nguonDonText') {
      result = nguonDonText
    }
    if (type === 'nguonDontype') {
      result = nguonDontype
    }
    return result;
  }

  getLocal(data) {
    let address = [];
    if (data) {
      if (data.diaChi) {
        address.push(data.diaChi);
      }
      if (data.toThon) {
        address.push(data.toThon);
      }
      if (data.phuongXaCongDan && data.phuongXaCongDan.ten) {
        address.push(data.phuongXaCongDan.ten);
      }
      if (data.quanHuyenCongDan && data.quanHuyenCongDan.ten) {
        address.push(data.quanHuyenCongDan.ten);
      }
      if (data.tinhThanhCongDan && data.tinhThanhCongDan.ten) {
        address.push(data.tinhThanhCongDan.ten);
      }
    }
    return address.join(", ");
  }

  render() {
    let data = this.props.item;
    if (!data) {
      return null;
    }
    let donId = data.donCuId;
    let linkToDetailPage = '/chi-tiet-don-cu/' + donId;
    let linkToProcessPage = '';
    let nguonDonText = this.checkNguonDon('nguonDonText');
    let nguonDontype = this.checkNguonDon('nguonDontype');
    const types = ['TRUC_TIEP', 'CHUYEN_DON', 'GIAO_TTXM', 'GIAO_KTDX', 'GIAO_TDTH'];
    if (!types.includes(nguonDontype) && !data.trinhLanhDao) {
      linkToProcessPage = `/xu-ly-don-cu/chinh-sua/${donId}`;
    }
    let userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
    let showDelete = data.donViXuLyGiaiQuyetInfo && userInfo.donViId === data.donViXuLyGiaiQuyetInfo.coQuanQuanLyId;
    const { loaiThongTinDonInfo } = this.props.item;
    return (
      <tr>
        <td>{this.props.count}</td>
        <td>
          <ul className="list-items-table">
            {this.showThongTinCongDan()}
          </ul>
        </td>
        <td>
          <ul className="list-items-table">
            <li>
              <Link
                className="txt-underline"
                to={linkToDetailPage} >
                <TextTruncate
                  line={3}
                  truncateText="…"
                  text={this.props.item.noiDung}
                />
              </Link>
            </li>
          </ul>
        </td>
        <td>
          <ul className="list-items-table">
            <li>
              {this.props.item.loaiDonInfo ? this.props.item.loaiDonInfo.ten : ''}
            </li>
            <li>{this.props.item.soNguoi ? (this.props.item.soNguoi + ' người') : ''}</li>
          </ul>
        </td>
        <td>
          <ul className="list-items-table">
            <li>{nguonDonText}</li>
          </ul>
        </td>
        <td>
          <ul className="list-items-table">
            <li>{get(loaiThongTinDonInfo, 'ten')}</li>
          </ul>
        </td>
        <td>
          <div className="todo-wrap two-item">
            <ShowIf condition={CheckPermission('DONCU_SUA')}>
              <div className="wrap-link-todo">
                <Link className="itt-redirect" to={linkToProcessPage}>Chỉnh sửa</Link>
              </div>
            </ShowIf>
            <ShowIf condition={CheckPermission('DONCU_XOA') && showDelete}>
              <DeleteDialog
                title={'Xoá đơn thư'}
                content={'Bạn có đồng ý xóa đơn thư này không?'}
                redux={this.props.parent}
                deleteId={this.props.item.donCuId}
              />
            </ShowIf>
          </div>
        </td>
      </tr>
    )
  }
}

RowItemListHandleOldLetters.defaultProps = {
  dataLoaiDonThu: []
}

let bindStateToProps = state => {
  return {
    userInfo: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {},
    dataLoaiDonThu: state.duLieuHeThong.loaiDonThu
  }
}

export default connect(bindStateToProps)(RowItemListHandleOldLetters);



// WEBPACK FOOTER //
// ./src/components/modules/handle-letters-old/datatable/list/RowItemListHandleOldLetters.jsx